import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Button } from "antd"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface dataType {
    create_time: string // 创建时间
    id: string //跟进记录id
    follow_man_name: string // 跟进人
    follow_time: string // 跟进时间
    follow_level_name: string // 跟进等级名称
    follow_way_name: string // 跟进方式名称
    follow_content: string // 跟进内容
    is_effective_customer: string // 是否有效客资
    no_effective_reason_desc: string // 无效原因
    is_effective_clue: string // 是否有效线索
    is_invite_visit: string // 是否邀约进店
    visit_date: string // 邀约进店日期
    visit_store_name: string // 邀约进店门店
    next_follow_limit_date: string // 下次跟进截止日期
    distributed_sales_name: string // 分配销售
    remark: string // 备注
}

export default function () {

    const param: { id: string } = useParams()
    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<dataType[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/detail/follow_records', {
            params: {
                page,
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res.records.length > 0) {
                let d = data
                setData([...d, ...res.records])

            } else {
                setShowLoadBtn(false)
            }
        })
    }, [page])

    return <div className="follow-record">
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 销售跟进记录 */}
        {data.length === 0 && '暂无数据'}

        {data.map((el: dataType) => <ul style={{ listStyle: 'none' }}>
            <li>
                <p className="date">跟进日期：{el.follow_time}</p>
            </li>
            <li>
                <p>跟进销售：{el.follow_man_name}</p>
            </li>
            <li>
                <p>跟进等级：{el.follow_level_name} </p>
            </li>
            <li>
                <p>跟进方式：{el.follow_way_name} </p>
            </li>
            <li>
                <p>跟进内容：{el.follow_content}</p>
            </li>
            <li>
                <p>是否有效：{el.is_effective_clue}</p>
            </li>
            <li>
                <p>邀约进店：{el.visit_store_name}</p>
            </li>
            <li>
                <p>下次跟进：{el.next_follow_limit_date}</p>
            </li>
            <li>
                <p>备 注：{el.remark}</p>
            </li>
        </ul>)}

        {showLoadBtn && <Button onClick={() => {
            setPage(page + 1)
        }}>加载更多数据</Button>}
    </div>
}